// "Escribir el copy con IA" para un post del calendario —
// ADR-2026-09-15-el-copy-se-pide-por-archivos-y-entiende-el-carrusel.
//
// Reusa la MISMA herramienta que la pestaña de contenido
// (`/v1/images/instagram-description`), que ya tiene los prompts buenos y el
// contexto de la marca. Lo único que cambia es cómo se dice sobre qué escribir:
// por NOMBRES DE ARCHIVO en vez de por el id de una creación.
//
// Hacen falta los nombres por dos motivos, y los dos son reales acá:
//   · Un post puede ser un carrusel, y el copy tiene que hablar del conjunto.
//   · Un archivo SUBIDO por el usuario no tiene fila en `imagenes_generadas`,
//     así que no hay `image_id` que mandar.
//
// De un video se describe su póster; eso lo resuelve el backend.

import { USE_ATLAS_BACKEND } from '../../../config';
import { atlasBackendFetch } from '../../../lib/atlasBackend';

/** Mirar varias fotos y escribir lleva su tiempo; después ya no vale la pena esperar. */
const TIMEOUT_MS = 90_000;

export async function escribirCopy(
  fileNames: string[],
): Promise<{ texto: string | null; error: string | null }> {
  if (fileNames.length === 0) {
    return { texto: null, error: 'Agregá al menos una foto o un video primero' };
  }
  // El camino viejo por n8n sólo sabe recibir un `image_id`: no puede describir
  // un carrusel ni un archivo subido. Decirlo es mejor que mandar un pedido que
  // el otro lado no entiende.
  if (!USE_ATLAS_BACKEND) {
    return { texto: null, error: 'La escritura con IA no está disponible en este entorno' };
  }

  const ctrl = new AbortController();
  const reloj = window.setTimeout(() => ctrl.abort(), TIMEOUT_MS);
  try {
    const res = await atlasBackendFetch(
      '/v1/images/instagram-description',
      { file_names: fileNames, modo_utilizado: 'descripcion_instagram' },
      { signal: ctrl.signal },
    );
    const data = (await res.json().catch(() => null)) as {
      response?: string;
      post_description?: string;
      error?: string;
    } | null;
    const texto = data?.post_description?.trim();
    if (!res.ok || data?.response !== 'success' || !texto) {
      return { texto: null, error: data?.error || 'No se pudo escribir el copy' };
    }
    return { texto, error: null };
  } catch (e) {
    const abortada = e instanceof DOMException && e.name === 'AbortError';
    return {
      texto: null,
      error: abortada ? 'La IA tardó demasiado. Probá de nuevo.' : 'No se pudo escribir el copy',
    };
  } finally {
    window.clearTimeout(reloj);
  }
}
